var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.26 24.569 3.512-1.898.445.515-5.83 5.83c-1.333 1.31-3.464 1.31-4.775 0L3.983 18.387c-1.31-1.333-1.31-3.464 0-4.775l10.63-10.629c1.333-1.31 3.464-1.31 4.775 0l9.107 9.107-2.95-.093s-1.99 0-2.95-3.746c0 0-1.99 2.014-.327 4.59l-1.99 2.013-1.522-.117s-1.522-.117-2.833-3.278c0 0-1.639 1.428-.445 4.12 0 0-5.993-1.966-5.08-6.203 0 0-2.107 3.535 1.803 9.036 0 .001-.21 3.045.375 3.396l1.17.702-.701 1.17 8.217.89zm-1.03-7.75a3.198 3.198 0 0 1-1.474 1.1c-.164.07-.117.304.047.327 2.06.188 1.85-.795 1.732-1.31-.047-.164-.21-.258-.304-.118z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnx);
export default __webpack_public_path__ + "static/media/BNX.c2b9c107150cce446da6a1c3df8cabef.svg";
export { ForwardRef as ReactComponent };